import { observer } from 'mobx-react-lite'
import { ConjunctionFilter } from '@/features/legends/filters/components/ConjunctionFilter'
import { FiltersBuilderContainer } from '@/features/legends/filters/components/FiltersBuilder/FiltersBuilderContainer'
import type { ConjunctionEditorViewModel } from '@/features/legends/filters/types/ConjunctionEditorViewModel'

export interface ConjunctionFilterContainerProps {
  vm: ConjunctionEditorViewModel
  isDisabled?: boolean
  testId?: string
}

export const ConjunctionFilterContainer = observer(
  function ConjunctionFilterContainer({
    vm,
    isDisabled,
    testId,
  }: ConjunctionFilterContainerProps) {
    return (
      <ConjunctionFilter
        op={vm.op}
        onOpChange={vm.setOp}
        error={vm.validation.getError('rules')}
        isDisabled={isDisabled}
        testId={testId}
      >
        <FiltersBuilderContainer
          vm={vm.rules}
          isDisabled={isDisabled}
          emptyText={null}
          childLabel={vm.op === 'All' ? 'AND' : 'OR'}
          testId={testId && `${testId}-filters`}
        />
      </ConjunctionFilter>
    )
  },
)
